// Bilingual translations (EN/ID) for AsiaCommerce landing page
export const translations = {
  en: {
    nav: {
      features: "Features",
      howItWorks: "How it works",
      ecosystem: "Ecosystem",
      faq: "FAQ",
      login: "Sign In",
      register: "Register",
    },
    hero: {
      eyebrow: "B2B WHOLESALE · GROSIR HUB",
      title1: "Source Unique Global Products &",
      titleAccent: "Maximize Your Profit Margin",
      title2: "Like a Pro",
      subtitle:
        "Access exclusive local & import products (China) not available on Shopee. Get the lowest wholesale prices, automatic margin calculators, and ready-to-use marketing kits.",
      ctaPrimary: "Register Now & Start Trading",
      ctaSecondary: "See How It Works",
      trustChip: "Join 2,800+ active resellers",
      stat1: "Verified Suppliers",
      stat2: "Avg. Margin",
      stat3: "Countries",
    },
    problem: {
      eyebrow: "THE GAP",
      title: "Selling common marketplace products is a race to the bottom",
      subtitle:
        "Every reseller is fighting for the same customer on Shopee & Tokopedia. You cut the price, you lose the margin. There's a smarter way.",
      pain1Title: "Endless Price Wars",
      pain1Body: "Same products, 50 sellers, margin ≈ 0.",
      pain2Title: "Zero Differentiation",
      pain2Body: "Your catalog looks identical to everyone else's.",
      pain3Title: "No Marketing Assets",
      pain3Body: "You DIY content from scratch for every product.",
      solutionTitle: "AsiaCommerce gives you the unfair advantage",
      solutionBody:
        "Non-marketplace products with high perceived value, tiered wholesale pricing, and a complete marketing ecosystem — so you can sell before you even buy.",
      bullet1: "Exclusive non-marketplace catalog",
      bullet2: "Guaranteed lowest wholesale prices",
      bullet3: "Ready-to-post marketing kits",
    },
    features: {
      eyebrow: "THE MAGIC TOOLS",
      title: "Everything a smart reseller needs — in one hub",
      f1Title: "Unique Product Sourcing",
      f1Body:
        "Curated catalog of local & China-imported goods that your competitors cannot find on Shopee. Fresh drops every week.",
      f2Title: "Tiered Pricing & Margin Calculator",
      f2Body:
        "Real-time automatic calculation of your potential profit at every quantity tier. Know your margin before you order.",
      f3Title: "The Ultimate Marketing Kit",
      f3Body:
        "High-quality videos (China/Local), banners, and lifestyle photos ready for TikTok, Instagram & WhatsApp. Sell before you buy.",
      calcTitle: "Try the Margin Calculator",
      calcSubtitle: "Move the slider to see your instant profit projection.",
      calcWholesale: "Wholesale Cost",
      calcRetail: "Your Retail Price",
      calcQty: "Monthly Qty",
      calcProfit: "Projected Monthly Profit",
      calcMargin: "Profit Margin",
    },
    ecosystem: {
      eyebrow: "THE ECOSYSTEM",
      title: "A 2-sided marketplace built for real synergy",
      subtitle:
        "We connect suppliers and brand owners with a ready-to-buy pool of resellers. We arm resellers with unique high-margin inventory. Everyone wins inside one hub.",
      supplierSide: "For Suppliers",
      supplierBenefit1: "Instant buyer pool of 2,800+ resellers",
      supplierBenefit2: "Zero marketplace fee cannibalization",
      supplierBenefit3: "Bulk predictable orders",
      traderSide: "For Resellers",
      traderBenefit1: "Lowest guaranteed wholesale prices",
      traderBenefit2: "Unique SKUs not on Shopee",
      traderBenefit3: "Full marketing kit included",
    },
    products: {
      eyebrow: "CATALOG PREVIEW",
      title: "Products your competitors can't find",
      subtitle: "A peek into our curated non-marketplace inventory.",
      tag1: "Hot Pick",
      tag2: "New Arrival",
      tag3: "Bestseller",
      tag4: "Limited",
      unlock: "Unlock Full Catalog",
    },
    testimonials: {
      eyebrow: "TRUSTED BY RESELLERS",
      title: "Real stories from real resellers",
      t1: "My monthly revenue doubled after switching to AsiaCommerce. The marketing kit alone saved me 20 hours per week.",
      t1Name: "Rina S.",
      t1Role: "Fashion Reseller · Bandung",
      t2: "I was losing margin on Shopee. Now I sell unique products via WhatsApp using their video assets — no competition.",
      t2Name: "Budi P.",
      t2Role: "Home & Living Reseller · Surabaya",
      t3: "The margin calculator is a game changer. I know exactly how much I'll make before I order. No more guessing.",
      t3Name: "Citra A.",
      t3Role: "Beauty Supplies · Jakarta",
    },
    faq: {
      eyebrow: "QUESTIONS",
      title: "Frequently asked questions",
      q1: "Who is AsiaCommerce for?",
      a1: "Resellers, wholesalers, and aspiring entrepreneurs who want to source unique, high-margin products not available on common marketplaces.",
      q2: "Do I need minimum order quantity?",
      a2: "Most products have a small MOQ (Minimum Order Quantity) designed for small resellers. Tiered pricing rewards higher volume.",
      q3: "Can I really get ready-made marketing content?",
      a3: "Yes. Every product in our catalog ships with video, banner, and lifestyle photo assets — ready to post on TikTok, Instagram, or WhatsApp.",
      q4: "How do I source from China?",
      a4: "We handle supplier verification, consolidation, and shipping. You pick the product, we deliver to your door.",
      q5: "Is registration free?",
      a5: "Yes, creating an account is 100% free. You only pay for the products you order.",
    },
    finalCta: {
      title: "Stop competing on price. Start winning on product",
      subtitle: "Register in 60 seconds and unlock the full AsiaCommerce catalog today.",
      cta: "Register Now — It's Free",
    },
    footer: {
      tagline: "Global Sourcing & Cross Border Solution",
      product: "Product",
      company: "Company",
      resources: "Resources",
      legal: "Legal",
      about: "About",
      careers: "Careers",
      contact: "Contact",
      blog: "Blog",
      help: "Help Center",
      terms: "Terms",
      privacy: "Privacy",
      copy: "© 2025 AsiaCommerce Hub. All rights reserved.",
    },
  },
  id: {
    nav: {
      features: "Fitur",
      howItWorks: "Cara Kerja",
      ecosystem: "Ekosistem",
      faq: "FAQ",
      login: "Masuk",
      register: "Daftar",
    },
    hero: {
      eyebrow: "B2B WHOLESALE · GROSIR HUB",
      title1: "Belanja Produk Unik Dunia &",
      titleAccent: "Lipatgandakan Profit Anda",
      title2: "Tanpa Ribet",
      subtitle:
        "Akses produk lokal & impor (China) eksklusif yang tidak ada di Shopee. Dapatkan harga grosir termurah, kalkulator margin otomatis, dan marketing kit siap pakai.",
      ctaPrimary: "Daftar Sekarang & Mulai Jualan",
      ctaSecondary: "Lihat Cara Kerjanya",
      trustChip: "Bergabung dengan 2.800+ reseller aktif",
      stat1: "Supplier Terverifikasi",
      stat2: "Rata-rata Margin",
      stat3: "Negara",
    },
    problem: {
      eyebrow: "MASALAHNYA",
      title: "Jualan produk marketplace biasa = perang harga tanpa akhir",
      subtitle:
        "Semua reseller rebutan pembeli yang sama di Shopee & Tokopedia. Harga dipotong, margin hilang. Ada cara yang lebih cerdas.",
      pain1Title: "Perang Harga Tak Berujung",
      pain1Body: "Produk sama, 50 penjual, margin hampir 0.",
      pain2Title: "Tidak Ada Pembeda",
      pain2Body: "Katalog Anda mirip semua kompetitor.",
      pain3Title: "Tidak Ada Aset Marketing",
      pain3Body: "Bikin konten dari nol tiap produk.",
      solutionTitle: "AsiaCommerce Bisa Beri Anda Keuntungan Lebih yang Sulit Dikejar Kompetitor",
      solutionBody:
        "Produk Eksklusif, Harga Grosir Bertingkat, dan Support Marketing Kit Lengkap — Bangun Bisnis Berkelanjutan dengan Ekosistem yang Matang.",
      bullet1: "Katalog eksklusif non-marketplace",
      bullet2: "Harga grosir dijamin termurah dari marketplace manapun",
      bullet3: "Marketing kit siap posting",
    },
    features: {
      eyebrow: "SENJATA RAHASIA",
      title: "Ekosistem Lengkap Reseller: Cari Produknya, Ambil Kontennya, Raih Untungnya.",
      f1Title: "Sourcing Produk Unik",
      f1Body:
        "Katalog terkurasi produk lokal & impor China yang tidak bisa ditemukan kompetitor di Shopee. Produk baru tiap minggu.",
      f2Title: "Harga Bertingkat & Kalkulator Margin",
      f2Body:
        "Kalkulasi otomatis real-time potensi profit di setiap tier kuantitas. Tahu margin Anda sebelum order.",
      f3Title: "Marketing Kit Lengkap",
      f3Body:
        "Video premium (China/Lokal), banner, dan foto lifestyle sudah siap. Ambil produknya, gunakan marketing kit-nya, dan langsung mulai jualan di TikTok, IG, & WA.",
      calcTitle: "Coba Kalkulator Margin",
      calcSubtitle: "Geser slider untuk melihat proyeksi profit instan.",
      calcWholesale: "Harga Grosir",
      calcRetail: "Harga Jual Anda",
      calcQty: "Qty per Bulan",
      calcProfit: "Proyeksi Profit Bulanan",
      calcMargin: "Margin Profit",
    },
    ecosystem: {
      eyebrow: "EKOSISTEM",
      title: "Marketplace 2 sisi yang dibangun untuk sinergi nyata",
      subtitle:
        "Kami sediakan supplier/brand owner dengan buyer pool siap beli. Kami bekali reseller dengan inventory unik bermargin tinggi. Semua untung dalam satu Hub ini.",
      supplierSide: "Untuk Supplier",
      supplierBenefit1: "Buyer pool langsung 2.800+ reseller",
      supplierBenefit2: "Tanpa kanibalisasi fee marketplace",
      supplierBenefit3: "Order bulk yang terprediksi",
      traderSide: "Untuk Reseller",
      traderBenefit1: "Harga grosir termurah dijamin",
      traderBenefit2: "SKU unik yang tidak ada di Shopee",
      traderBenefit3: "Marketing kit lengkap disertakan",
    },
    products: {
      eyebrow: "PREVIEW KATALOG",
      title: "Produk yang tidak bisa ditemukan kompetitor Anda",
      subtitle: "Intip katalog non-marketplace terkurasi kami.",
      tag1: "Paling Dicari",
      tag2: "Baru Datang",
      tag3: "Bestseller",
      tag4: "Limited",
      unlock: "Buka Katalog Lengkap",
    },
    testimonials: {
      eyebrow: "DIPERCAYA RESELLER",
      title: "Cerita nyata dari reseller nyata",
      t1: "Omset bulanan saya 2x lipat sejak pakai AsiaCommerce. Marketing kit-nya saja hemat waktu saya 20 jam per minggu.",
      t1Name: "Rina S.",
      t1Role: "Reseller Fashion · Bandung",
      t2: "Saya rugi margin di Shopee. Sekarang jualan produk unik via WhatsApp pakai video mereka — tanpa kompetisi.",
      t2Name: "Budi P.",
      t2Role: "Reseller Home & Living · Surabaya",
      t3: "Kalkulator margin ini game changer. Saya tau persis berapa untung sebelum order. Tidak main tebak-tebakan lagi.",
      t3Name: "Citra A.",
      t3Role: "Beauty Supplies · Jakarta",
    },
    faq: {
      eyebrow: "PERTANYAAN",
      title: "Pertanyaan yang sering diajukan",
      q1: "AsiaCommerce cocok untuk siapa?",
      a1: "Reseller, grosiran, dan calon pengusaha yang mau sourcing produk unik margin tinggi yang tidak ada di marketplace umum.",
      q2: "Apakah ada minimum order?",
      a2: "Sebagian besar produk punya MOQ kecil yang dirancang untuk reseller kecil. Harga bertingkat memberikan bonus untuk volume lebih besar.",
      q3: "Benarkah dapat konten marketing siap pakai?",
      a3: "Ya. Setiap produk di katalog kami dilengkapi video, banner, dan foto lifestyle — siap posting di TikTok, Instagram, atau WhatsApp.",
      q4: "Bagaimana cara sourcing dari China?",
      a4: "Kami handle verifikasi supplier, konsolidasi, dan pengiriman. Anda pilih produk, kami antar ke pintu Anda.",
      q5: "Apakah pendaftaran gratis?",
      a5: "Ya, buat akun 100% gratis. Anda hanya bayar produk yang di-order.",
    },
    finalCta: {
      title: "Berhenti perang harga. Mulai menang di produk",
      subtitle: "Daftar dalam 60 detik dan buka katalog AsiaCommerce lengkap hari ini.",
      cta: "Daftar Sekarang — Gratis",
    },
    footer: {
      tagline: "Global Sourcing & Cross Border Solution",
      product: "Produk",
      company: "Perusahaan",
      resources: "Sumber Daya",
      legal: "Legal",
      about: "Tentang",
      careers: "Karir",
      contact: "Kontak",
      blog: "Blog",
      help: "Pusat Bantuan",
      terms: "Syarat",
      privacy: "Privasi",
      copy: "© 2025 AsiaCommerce Hub. Seluruh hak dilindungi.",
    },
  },
};
